export class docVacacionesModel {
  fechaVacaciones: string;
  nombre: string;
  legajo: string;
  seccion: string;
  textoA: string;
  textoB: string;
  fechaImpresion: string;
}
